module.exports = __webpack_public_path__ + "img/ultra_2_feature_02.c0a40f98.jpg";